import React from 'react';
import { ChevronRight, Leaf } from 'lucide-react';
import styles from './FoodWrapStyleHero.module.css';

const FoodWrapStyleHero = ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  imageLeft,
  imageRight,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.heroContainer}>
      <div className={styles.imageLayoutCol}>
        <div className={styles.dynamicFrameContainer}>
          <div className={styles.frameLeft}>
            <img src={imageLeft.src} alt={imageLeft.alt} className={styles.equalImg} />
          </div>
          <div className={styles.frameRight}>
            <img src={imageRight.src} alt={imageRight.alt} className={styles.equalImg} />
          </div>
          <div className={styles.creativeIntersectionBox}>
            <div className={styles.brandLeafBox}>
              <div className={styles.innerDoubleBorder}>
                <Leaf size={28} className={styles.orangeLeafIcon} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.textLayoutCol}>
        <div className={styles.badgeWrapper}>
          <span className={styles.miniTag}>{badge}</span>
        </div>
        <div className={styles.titleArea}>
          <span className={styles.scriptTitle}>{scriptTitle}</span>
          <h1 className={styles.boldTitle}>{boldTitle}</h1>
        </div>
        {descriptions.slice(0, 2).map((text, index) => (
          <p key={index} className={styles.heroDescription}>
            {text}
          </p>
        ))}
        {features?.length > 0 && (
          <div className={styles.featuresList}>
            {features.map((feature, index) => (
              <div key={index} className={styles.featureItem}>
                <ChevronRight size={16} className={styles.featureIcon} />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  </section>
);

export default FoodWrapStyleHero;
